export enum AppEventEnum {
    PerdaLoteView = 1,
    AutorizacaoOpcoes = 2,
    GerenciarMedicamentos = 3,
    FinalizarOperacao = 4,
    InventarioMedicamentoOpcoes = 5
}